// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const EmployeeService = {};

EmployeeService.postEmployee = function (data) {
  return lossClient({
    url: "/employee",
    method: "post",
    data: data,
  });
};

EmployeeService.getEmployeeList = function (data) {
  return lossClient({
    url: "/employee",
    method: "get",
    data: data,
  });
};

EmployeeService.getEmployeeDetail = function (data) {
  return lossClient({
    url: `/employee/${data.id}`,
    method: "get",
  });
};

EmployeeService.updateEmployee = function (data) {
  return lossClient({
    url: `/employee/${data.id}`,
    method: "put",
    data: data,
  });
};

EmployeeService.deleteEmployee = function (data) {
  return lossClient({
    url: `/employee/${data.id}`,
    method: "delete",
  });
};

EmployeeService.searchEmployee = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  const params = {};
  if (userInput?.pageSize !== undefined && userInput?.pageSize !== null)
    params.pageSize = userInput.pageSize;
  params.pageIndex = decrementIndex;
  if (userInput?.branchid) params.branchid = userInput.branchid;
  if (userInput?.employeename) params.employeename = userInput.employeename;
  if (userInput?.employeePosition)
    params.employeePosition = userInput.employeePosition;
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
  return lossClient({
    url: `/Employee/search?${queryString}`,
    method: "get",
  });
};

export default EmployeeService;
